import {fileServerPath} from "../../../api";
import {ICustomEmoji} from "./types";

/** Имя → эмодзи: быстрый поиск при разборе текста и реакций. */
export type CustomEmojiMap = Record<string, ICustomEmoji>;

export const toEmojiMap = (list: ICustomEmoji[]): CustomEmojiMap =>
    Object.fromEntries(list.map((e) => [e.name, e]));

export const emojiUrl = (e: Pick<ICustomEmoji, "file_name">): string =>
    `${fileServerPath}/${encodeURIComponent(e.file_name)}`;

/** Код `:name:` целиком (реакция хранится этой строкой). */
const CODE_RE = /^:([a-z0-9_]{2,32}):$/;

/** Реакция строкой `:name:` → командное эмодзи, если такое есть; иначе null (обычный эмодзи-символ). */
export const customFromCode = (code: string, map: CustomEmojiMap): ICustomEmoji | null => {
    const m = CODE_RE.exec(code);
    return m ? map[m[1]] ?? null : null;
};

const escapeAttr = (s: string) => s.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");

/** `<img>` командного эмодзи в тексте сообщения (20 px — стилем `.cemoji`). */
export const customEmojiImg = (e: ICustomEmoji): string => {
    const code = escapeAttr(`:${e.name}:`);
    return `<img class="cemoji" src="${escapeAttr(emojiUrl(e))}" alt="${code}" title="${code}">`;
};

/**
 * `:name:` в HTML после `marked` → картинка командного эмодзи. Внутри тегов
 * (атрибуты ссылок), `<code>` и `<pre>` код не трогается; неизвестное имя
 * остаётся текстом.
 */
export const replaceCustomEmoji = (html: string, map: CustomEmojiMap): string => {
    if (!html.includes(":")) return html;
    return html.replace(
        /(<pre[\s\S]*?<\/pre>|<code[\s\S]*?<\/code>|<[^>]*>)|:([a-z0-9_]{2,32}):/g,
        (whole, skip: string | undefined, name: string | undefined) => {
            if (skip) return skip;
            const e = name ? map[name] : undefined;
            return e ? customEmojiImg(e) : whole;
        },
    );
};
